<div class="mb-2">
  <span class="secondary-details mb-2">{{
    'configuration.additionalServices.additionalServices' | translate
  }}</span>
</div>

<div class="example-container" [formGroup]="additionalServiceDetails">
  <div formArrayName="data">
    <ng-container>
      <div class="custom-card">
        <table aria-describedby="package-table" mat-table [dataSource]="addtServiceDataSource">
          <ng-container matColumnDef="number">
            <th style="width: 10%" id="number" mat-header-cell *matHeaderCellDef>
              {{ 'configuration.additionalServices.number' | translate }}*
            </th>
            <td style="width: 10%" mat-cell *matCellDef="let row; let i = index">
              {{ i + 1 }}
            </td>
          </ng-container>

          <ng-container matColumnDef="spServiceCode">
            <th style="width: 20%" id="spServiceCode" mat-header-cell *matHeaderCellDef>
              {{ 'configuration.additionalServices.specialServiceCode' | translate }}*
            </th>
            <td style="width: 20%" mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
              <input
                maxlength="2"
                [ngStyle]="{
                  'border-color': getAddtnlServiceFormControlId(i, 'serviceCode').errors
                    ? 'red'
                    : 'grey'
                }"
                type="text"
                [readonly]="!editable"
                style="width: 90%"
                class="form-control"
                formControlName="serviceCode" />
            </td>
          </ng-container>

          <ng-container matColumnDef="globalServiceName">
            <th style="width: 30%" id="globalServiceName" mat-header-cell *matHeaderCellDef>
              {{ 'configuration.additionalServices.globalServiceName' | translate }}*
            </th>
            <td style="width: 30%" mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
              <select
                (change)="setadditionalServiceCode(i, $event.target.value)"
                style="width: 90%"
                [ngStyle]="{
                  'border-color': getAddtnlServiceFormControlId(i, 'globalServiceName').errors
                    ? 'red'
                    : 'grey'
                }"
                class="form-control"
                formControlName="globalServiceName">
                <option *ngFor="let item of globalServiceNames" [value]="item.label">
                  {{ item.label }}
                </option>
              </select>
            </td>
          </ng-container>

          <ng-container matColumnDef="baby">
            <th style="width: 20%" id="baby" mat-header-cell *matHeaderCellDef>
              {{ 'configuration.additionalServices.baby' | translate }}*
            </th>
            <td style="width: 20%" mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
              <select
                style="width: 90%"
                [ngStyle]="{
                  'border-color': getAddtnlServiceFormControlId(i, 'isBaby').errors ? 'red' : 'grey'
                }"
                class="form-control"
                formControlName="isBaby">
                <option *ngFor="let item of trueFalseOptions" [value]="item.value">
                  {{ item.label }}
                </option>
              </select>
            </td>
          </ng-container>
          <ng-container matColumnDef="mother">
            <th style="width: 10%" id="mother" mat-header-cell *matHeaderCellDef>
              {{ 'configuration.additionalServices.mother' | translate }}*
            </th>
            <td style="width: 10%" mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
              <select
                style="width: 90%"
                [ngStyle]="{
                  'border-color': getAddtnlServiceFormControlId(i, 'isMother').errors
                    ? 'red'
                    : 'grey'
                }"
                class="form-control"
                formControlName="isMother">
                <option *ngFor="let item of trueFalseOptions" [value]="item.value">
                  {{ item.label }}
                </option>
              </select>
            </td>
          </ng-container>
          <ng-container matColumnDef="individualShipment">
            <th style="width: 20%" id="baby" mat-header-cell *matHeaderCellDef>
              {{ 'configuration.additionalServices.individualShipment' | translate }}*
            </th>
            <td style="width: 20%" mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
              <select
                style="width: 90%"
                [ngStyle]="{
                  'border-color': getAddtnlServiceFormControlId(i, 'isIndividualShipment').errors
                    ? 'red'
                    : 'grey'
                }"
                class="form-control"
                formControlName="isIndividualShipment">
                <option *ngFor="let item of trueFalseOptions" [value]="item.value">
                  {{ item.label }}
                </option>
              </select>
            </td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th style="width: 10%" id="action" mat-header-cell *matHeaderCellDef>
              {{ 'global.action' | translate }}
            </th>
            <td style="width: 10%" mat-cell *matCellDef="let row; let i = index">
              <button (click)="deleteServiceConfig(pieces, i)" class="secondary-btn" type="button">
                {{ 'global.delete' | translate }}
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: columns"></tr>

          <tr class="mat-row justify-content-center" *matNoDataRow>
            {{
              'global.noDataAvailable' | translate
            }}
          </tr>
        </table>
      </div>
    </ng-container>
  </div>
  <button
    [disabled]="!(this.additionalServiceDetails.valid && isValueChanged)"
    (click)="saveAddtnlServiceConfig()"
    class="ml-2 mt-2 primary-btn float-right"
    type="button">
    {{ 'global.save' | translate }}
  </button>
  <button (click)="addNewServiceConfig()" class="ml-2 mt-2 secondary-btn float-right" type="button">
    {{ 'global.addRow' | translate }}
  </button>
</div>
